
/**
 * This aproach https://stackoverflow.com/a/45252132 but with mandatory line height value.
 * Otherwise it's not possible to count lines with acceptable precicion.
 */
export const getLinesNumberForTextAreaElement = (
  textarea: HTMLTextAreaElement,
  lineHeightSubstitute: number
): number => {
  const tmpTextArea = document.createElement('textarea');
  const id = String(Date.now());

  tmpTextArea.id = id;
  tmpTextArea.style.border = 'none';
  tmpTextArea.style.height = '0';
  tmpTextArea.style.overflow = 'hidden';
  tmpTextArea.style.padding = '0';
  tmpTextArea.style.position = 'absolute';
  tmpTextArea.style.left = '0';
  tmpTextArea.style.top = '0';
  tmpTextArea.style.zIndex = '-1';
  document.body.appendChild(tmpTextArea);

  const computedStyle = window.getComputedStyle(textarea);
  const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
  const paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
  const lineHeight = parseInt(computedStyle.lineHeight, 10) || lineHeightSubstitute;

  tmpTextArea.style.width = `${textarea.clientWidth - paddingLeft - paddingRight}px`;
  tmpTextArea.style.font = computedStyle.font;
  tmpTextArea.style.fontFamily = computedStyle.fontFamily;
  tmpTextArea.style.fontSize = computedStyle.fontSize;
  tmpTextArea.style.letterSpacing = computedStyle.letterSpacing;
  tmpTextArea.style.whiteSpace = computedStyle.whiteSpace;
  tmpTextArea.style.wordBreak = computedStyle.wordBreak;
  tmpTextArea.style.wordSpacing = computedStyle.wordSpacing;
  tmpTextArea.value = textarea.value;

  const result = Math.floor(tmpTextArea.scrollHeight / lineHeight) || 1;

  document.getElementById(id)?.remove();

  return result;
};
